export default "__VITE_ASSET__t9io9uIt__"